<template>
  <div>
    <div class="nav">
      <button :aria-disabled="false"
              :class="openTab===1?'sf-button--account account is-active':'sf-button--account account'"
              :link="null"
              @click="openTab=1">
        <SfIcon :icon="icons.userFill.path" :view-box="icons.userFill.viewBox" color="#051039"
                size="36px"></SfIcon>
        <span class="title" v-html="$t('account.modal.personal.title.html')"></span>
      </button>
      <button :aria-disabled="false"
              :class="openTab===2?'sf-button--account af is-active':'sf-button--account af'"
              :link="null"
              @click="openTab=2">
        <SfIcon :icon="icons.af.path" :view-box="icons.af.viewBox" color="#f00"
                size="42px"></SfIcon>
        <span class="title desktop-only" v-html="$t('account.modal.af.title.html')"></span>
        <span class="title smartphone-only" v-html="$t('account.modal.af.title.htmlMobile')"></span>
      </button>
      <!-- <button :aria-disabled="false"
                :class="openTab===3?'sf-button--account fb is-active':'sf-button--account fb'"
                :link="null"
                @click="openTab=3">
            <SfImage alt="Flying Blue" height="44px" src="/assets/images/flying-blue-logo.png"
                     width="42px"></SfImage>
            <span class="title" v-html="$t('account.modal.fb.title.html')"></span>
        </button>-->
    </div>
    <SfTabs
        :open-tab='openTab'
        class=''
    >
      <SfTab :title="$t('account.modal.personal.title.str')">
        <transition mode="out-in" name="sf-fade">
          <div class="login">
            <div class="login-col">
              <LogIn v-if="isLogin" @submit="loginForm" v-on:setIsForgotValue="setIsForgotValue($event)"/>
              <AuthFactor v-if="isAuth" class="form" @submit="authSubmit"></AuthFactor>
              <ForgotPassword v-if="isForgot" @submit="forgotForm"
                              v-on:setIsLoginValue="setIsLoginValue($event)"/>
            </div>

            <div class="login-col">
              <div class="form">
                <SignIn :show-login="false" @submit="signinForm"
                        v-on:setIsLoginValue="setIsLoginValue($event)"/>
              </div>
            </div>
          </div>
        </transition>
      </SfTab>
      <SfTab :title="$t('account.modal.af.title.str')" class="account--af">
        <div v-if="!gpnet" class="account--af--header">
          <SfHeading :level="3"
                     :title="$t('account.habile.title')">
          </SfHeading>
          <div class="action">
            <SfButton class="sf-button  color-white" @click="habileConnect">
              {{ $t('Habile sign in') }}
            </SfButton>
            <SfButton :disabled="false" class="sf-button  color-white" @click="gpnetConnect">
              {{ $t('GPNet sign in') }}
            </SfButton>
          </div>
        </div>
        <div v-if="gpnet" class="gpnet">


          <div v-if="isDefaultGpnet" class="gpnetActions">
            <SfHeading
                :level="3"
                :title="$t('GPNet sign in')">
              <template #description>
                <p class="sf-heading__description" v-html="$t('gpnetForm.login.description')"></p>
              </template>
            </SfHeading>
            <div class="action">
              <SfButton class="color-primary sf-button--full-width"
                        @click="setIsRegisterGpnetValue(false)">
                {{ $t('Create an employee account') }}
              </SfButton>

              <SfButton class="color-secondary sf-button--full-width"
                        @click="setIsLoginGpnetValue(true)">
                {{ $t('I already have an employee account') }}
              </SfButton>
            </div>
          </div>
          <div v-else-if="isLoginGpNet" class="content">
            <LogInGpNet @submit="loginGpnetForm"
                        v-on:setIsForgotGpnetValue="setIsForgotGpnetValue($event)"/>

            <div class="actions">
              <div class="bottom">
                <SfButton class="color-primary sf-button--full-width"
                          @click="setIsRegisterGpnetValue(false)">
                  {{ $t('Create an employee account') }}
                </SfButton>
              </div>
            </div>
          </div>
          <div v-else-if="isAuthGpnet" class="content">
            <AuthFactorGpnet @submit="authGpnetSubmit"></AuthFactorGpnet>
          </div>
          <div v-else-if="isForgotGpnet" class="content">
            <ForgotPasswordGpnet @submit="forgotGpnetForm"
                                 v-on:setIsLoginValue="setIsLoginGpnetValue($event)"/>
          </div>
          <div v-else class="content">
            <SignInGpnet :showLogin="true" @submit="signinGpnetForm"
                         v-on:setIsLoginValue="setIsLoginGpnetValue($event)"/>

          </div>

          <div class="actionHabile">
            <SfButton class="sf-button color-white" @click="habileConnect">
              {{ $t('Habile sign in') }}
            </SfButton>
          </div>

          <!--
                      <div class="login-col">
                        <LogInGpNet v-if="isLoginGpNet" @submit="loginGpnetForm"
                                    v-on:setIsForgotGpnetValue="setIsForgotGpnetValue($event)"/>
                        <AuthFactorGpnet v-if="isAuthGpnet" @submit="authGpnetSubmit"/>
                        <ForgotPasswordGpnet v-if="isForgotGpnet" @submit="forgotGpnetForm"
                                             v-on:setIsLoginValue="setIsLoginGpnetValue($event)"/>
                      </div>

                      <div class="login-col">
                        <SignInGpnet :showLogin="true" @submit="signinGpnetForm"
                                     v-on:setIsLoginValue="setIsLoginGpnetValue($event)"/>
                      </div>

                      -->

        </div>

      </SfTab>
      <!--<SfTab title="flyingBlue">
                 FlyingBlue
             </SfTab>-->
    </SfTabs>
  </div>
</template>
<script>

import {SfHeading, SfIcon, SfButton, SfTabs} from '@storefront-ui/vue';

import LogIn from '@/components/AccountForm/LogIn'
import ForgotPassword from '@/components/AccountForm/ForgotPassword'
import SignIn from '@/components/AccountForm/SignIn'
import Api from "@/api/Api";
import icons from "@/utils/icons";
import AuthFactor from "@/components/AccountForm/AuthFactor";
import LogInGpNet from "@/components/GpnetForm/LogIn";
import AuthFactorGpnet from "@/components/GpnetForm/AuthFactor";
import ForgotPasswordGpnet from "@/components/GpnetForm/ForgotPassword";
import SignInGpnet from "@/components/GpnetForm/SignIn";

export default {
  name: 'Login',
  components: {
    ForgotPassword,
    LogIn,
    SignIn,
    SfTabs,
    SfButton,
    SfIcon,
    SfHeading,
    AuthFactor,
    SignInGpnet,
    ForgotPasswordGpnet,
    AuthFactorGpnet,
    LogInGpNet
  },
  data() {
    return {
      isLogin: true,
      isAuth: false,
      isForgot: false,
      openTab: 1,
      icons: icons,
      customerForm: null,
      isDefaultGpnet: true,
      isLoginGpNet: false,
      gpnet: false,
      isAuthGpnet: false,
      isForgotGpnet: false,
    }
  },

  methods: {

    habileConnect() {
      this.gpnet = false;

      const url = process.env.VUE_APP_HABILE_HTTP_VERSION + '://' + process.env.VUE_APP_HABILE_HOST + process.env.VUE_APP_HABILE_API_ROUTE + 'authorization.oauth2?client_id=' + process.env.VUE_APP_HABILE_CLIENT_ID + '&redirect_uri=' + process.env.VUE_APP_HABILE_REDIRECT_URI + '&response_type=code&scope=openid email';
      this.toggleModal();
      window.location.href = url;

    },
    toggleModal() {
      this.isLogin = true;
      this.isAuth = false;
      this.isForgot = false;
      this.isLoginGpNet = true;
      this.gpnet = false;
      this.isAuthGpnet = false;
      this.isForgotGpnet = false;
      this.createAccount = false;
    },
    gpnetConnect() {
      this.gpnet = true;
    },

    setIsLoginValue(value) {
      this.isLogin = value;
      this.isForgot = !value;
    },
    setIsForgotValue(value) {
      this.isForgot = value;
      this.isLogin = !value;
    },

    setIsRegisterValue(value) {
      this.isForgot = value;
      this.isLogin = value;
    },
    loginForm({form, onComplete, onError}) {
      this.customerForm = form;

      Api.account.login(form)
          .then((data) => {
            onComplete(data)
            if (data.twoFactorAuthenticationEnabled) {
              this.isAuth = true;
              this.isLogin = false;
            } else {
              this.isAuth = false;
              this.isLogin = true;
              this.$store.dispatch('loginCustomer', data);
            }
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    signinForm({form, onComplete, onError}) {
      Api.account.register(form)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('loginCustomer', data);
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })
    },

    forgotForm({form, onComplete, onError}) {
      Api.account.resetPassword(form)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('toggleResetModal', {
              open: true,
              email: form.email
            });

          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    authSubmit({oneTimePassword, onComplete, onError}) {

      this.customerForm.oneTimePassword = oneTimePassword
      Api.account.loginOneTimePassword(this.customerForm)
          .then((data) => {
            onComplete(data)
            this.isAuth = false;
            this.isLogin = true;
            this.$store.dispatch('loginCustomer', data);
          })
          .catch((e) => {
            let error = '';
            const messageParts = e.message.split('|')
            const count = messageParts[1]

            switch (messageParts[0]) {
              case "The provided one time password doesn't match":
                error = this.$i18n.t('errors.auth.unauthorized')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "Too much attempts for one time password":
                error = this.$i18n.t('errors.auth.tooMuch')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "One time password is expired":
                error = this.$i18n.t('errors.auth.timeOut')
                break;
            }
            switch (e.status) {
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 404:
                error = this.$i18n.t('errors.notfound')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError({message: error, count})
          })
    },
    /* GPnet */
    loginGpnetForm({form, onComplete, onError}) {
      this.customerForm = form;

      Api.account.loginGpNet(form)
          .then((data) => {
            onComplete(data)


            if (data.twoFactorAuthenticationEnabled) {
              this.isAuthGpnet = true;
              this.isLoginGpNet = false;
            } else {
              this.isAuthGpnet = false;
              this.isLoginGpNet = true;
              this.$store.dispatch('loginCustomer', data);
            }
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 502:
                error = this.$i18n.t('errors.server.gpNet')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    signinGpnetForm({form, onComplete, onError}) {
      Api.account.registerGpNet(form)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('loginCustomer', data);
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 502:
                error = this.$i18n.t('errors.server.gpNet')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })
    },

    forgotGpnetForm({form, onComplete, onError}) {
      Api.account.resetPasswordGpNet(form)
          .then((data) => {
            onComplete(data)
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 502:
                error = this.$i18n.t('errors.server.gpNet')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })

    },

    authGpnetSubmit({oneTimePassword, onComplete, onError}) {

      this.customerForm.oneTimePassword = oneTimePassword
      Api.account.loginOneTimePasswordGpNet(this.customerForm)
          .then((data) => {
            onComplete(data)
            this.isAuthGpnet = false;
            this.isLoginGpNet = true;
            this.$store.dispatch('loginCustomer', data);
          })
          .catch((e) => {
            let error = '';
            const messageParts = e.message.split('|')
            const count = messageParts[1]

            switch (messageParts[0]) {
              case "The provided one time password doesn't match":
                error = this.$i18n.t('errors.auth.unauthorized')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "Too much attempts for one time password":
                error = this.$i18n.t('errors.auth.tooMuch')
                if (!count) {
                  this.isAuth = false;
                  this.isLogin = true
                }
                break;
              case "One time password is expired":
                error = this.$i18n.t('errors.auth.timeOut')
                break;
            }
            switch (e.status) {
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
              case 404:
                error = this.$i18n.t('errors.notfound')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError({message: error, count})
          })
    },

    setIsLoginGpnetValue(value) {
      this.isLoginGpNet = value;
      this.isForgotGpnet = !value;
      this.isDefaultGpnet = !value;
    },
    setIsForgotGpnetValue(value) {
      this.isForgotGpnet = value;
      this.isLoginGpNet = !value;
      this.isDefaultGpnet = !value;
    },

    setIsRegisterGpnetValue(value) {
      this.isForgotGpnet = value;
      this.isLoginGpNet = value;
      this.isDefaultGpnet = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.login {
  display: grid;
  flex-wrap: wrap;
  grid-template-columns:  repeat(2, 1fr);
  grid-gap: var(--spacer-2xl);
  justify-content: space-around;
  margin-top: var(--spacer-base);
  @include for-tablet {
    margin-top: 0;
    grid-template-columns: 1fr;
    grid-gap: var(--spacer-xl);
  }
  @include for-mobile {
    margin-top: 0;
    grid-template-columns: 1fr;
    grid-gap: var(--spacer-base);
  }
}


.modal {
  --modal-index: 3;
  --overlay-z-index: 3;
}

.form {
  margin-top: var(--spacer-sm);

  &__element {
    margin: 0 0 var(--spacer-xl) 0;
  }
}

.action {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
  font: var(--font-weight--normal) var(--font-size--base) / 1.6 var(--font-family--secondary);

  & > * {
    margin: 0 0 0 var(--spacer-xs);
  }
}

.nav {
  width: 100%;
  margin: auto;
  display: flex;
  background: #d2d2d2;
  box-shadow: 0 10px 10px -5px inset rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border-radius: 4px 4px 0 0;
  @include for-tablet {
    width: 100%;
  }
  @include for-mobile {
    width: 100%;
  }


  .sf-button--account {
    min-height: 48px;
    border-radius: 0;
    flex: 1;
    display: flex;
    text-align: left;
    align-items: center;
    background: rgba(255, 255, 255, 0);
    border: none;
    transition: 0.2s ease background;
    padding-left: var(--spacer-xl);

    &:first-of-type {
      border-radius: 4px 4px 0 0;
    }

    &:last-of-type {
      border-radius: 4px 4px 0 0;
    }


    .sf-icon {

      border-radius: 50%;
      border: 2px solid var(--c-primary);
      width: 36px;
      height: 36px;
      display: flex;
      justify-content: center;
      align-items: center;
      --icon-color: var(--c-primary) !important;

      .sf-icon-path {
        width: 20px;
        height: 20px;

      }

      @include for-mobile {

        --icon-size: 26x !important;
      }
    }

    .sf-image {
      @include for-mobile {
        --image-width: 26px !important;
      }
    }


    .title {
      font-family: var(--font-family--primary);
      margin-left: var(--spacer-xs);
      //   text-transform: uppercase;
      color: #585858;
      font-size: var(--font-size--base);
      line-height: 20px;
      font-weight: bold;
      transition: 0.2s ease color;
      @include for-mobile {
        font-size: 10px;
        line-height: 1;

      }
    }

    &.is-active, &:hover {
      background: rgba(255, 255, 255, 1);
      cursor: pointer;

      .title {
        color: var(--c-text)
      }
    }
  }
}

.action {
  margin: var(--spacer-xl) 0 var(--spacer-xl) 0;
}

.checkbox {
  margin-bottom: var(--spacer-2xl);
}

.gpnet {
  width: 50%;
  flex: 1;
  margin: var(--spacer-sm) auto 0;
  @include for-mobile {
    width: auto;
    flex: 1;
  }
  @include for-tablet {
    width: auto;
    flex: 1;
  }

  .content {
    padding: 0 var(--spacer-base);
    display: block;
  }
}

.account--af {

  .sf-heading {
    margin-bottom: var(--spacer-lg);
    padding: 0 var(--spacer-base);
    @include for-mobile {
      padding: 0;
    }

    .sf-heading__description {
      text-align: justify;

      p:last-of-type {
        text-align: center;
      }
    }
  }

  .actionHabile {
    margin-bottom: var(--spacer-xs);
    margin-top: var(--spacer-xs);
    display: flex;
    padding: 0 var(--spacer-base);
    @include for-mobile {

    }

    .sf-button {
      margin: var(--spacer-xs) 0;
      flex: 1;
      min-height: 42px;
      padding: var(--spacer-xs) var(--spacer-sm);
    }
  }

  .gpnetActions {
    flex-wrap: wrap;

    .sf-heading {
      width: 100%
    }
  }

  .action {

    padding: 0 var(--spacer-base);
    margin-bottom: var(--spacer-xs);
    display: flex;
    @include for-mobile {
      padding: 0;
    }

    .sf-button {
      margin: var(--spacer-xs) 0;
      flex: 1;
      min-height: 42px;
      padding: var(--spacer-xs) var(--spacer-sm);

      &:first-of-type:not(:last-of-type) {
        margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
      }

      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
      }
    }

    @include for-mobile {
      flex-wrap: wrap;
      .sf-button {
        width: 100%;
        flex: none;

        &:first-of-type:not(:last-of-type) {
          flex: none;
          margin: var(--spacer-sm) 0;
        }

        &:last-of-type:not(:first-of-type) {
          flex: none;
          margin: var(--spacer-sm) 0;
        }
      }
    }
  }


}


.gpnet {
  padding: 0 var(--spacer-base);
  margin-bottom: var(--spacer-base);

  .sf-heading__description {

    font-size: var(--font-size--lg);
    background: var(--_c-primary-background);
    margin: var(--spacer-base) 0;
    padding: var(--spacer-sm);
    border-radius: 4px;


  }

  @include for-mobile {
    padding: 0;
    .sf-heading__description {
      font-size: var(--font-size--base);
      line-height: 1.2;
    }
  }

  > div {
    padding: 0;
  }
}


.sf-tabs {
  padding: var(--spacer-base);

  @include for-mobile {
    padding: 0;
  }


  ::v-deep {

    .sf-tabs__title {
      display: none;
      @include for-mobile {
        display: none;
        background-color: var(--_c-primary-sidebar);
        margin-top: 0;

        // text-transform: uppercase;
        font-size: calc(var(--font-size--lg) * 1.25);
        box-shadow: inset 0 5px 20px -10px rgba(0, 0, 0, 0.2);
      }

      &[aria-pressed="true"] {
        @include for-mobile {

          box-shadow: inset 0 5px 20px -10px rgba(0, 0, 0, 0.2);
          background-color: var(--_c-primary-sidebar);
        }
      }
    }

    .sf-tabs__chevron {
      margin-left: auto;
    }

    .sf-tabs__content {

      border: none;
      @include for-mobile {
        display: flex;

        border-bottom: 1px solid var(--_c-lightgray);
        .sf-tabs__content__tab {
          padding: var(--spacer-base);

        }
      }
      @include for-tablet {
        display: flex;

      }
    }

    .sf-tabs__content__tab {
      min-height: 200px;
      padding-bottom: 0;
      width: 100%;
      @include for-mobile {
        padding: 0;
      }
    }
  }
}

.account--af--header {
  width: 50%;
  margin: 0 auto;
  @include for-mobile {
    width: 100%;
  }
  @include for-tablet {
    width: 100%;
  }
}


</style>
